import { render, staticRenderFns } from "./schemaManager.vue?vue&type=template&id=b3bb55f4&"
import script from "./schemaManager.vue?vue&type=script&lang=js&"
export * from "./schemaManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports